import React, { FC } from 'react';
import { Money } from '@edreamsodigeo/prisma-design-system';
import { MoneyComponentProps } from './types';

export const MoneyComponent: FC<MoneyComponentProps> = (args) => (
  <Money rounded {...args} />
);
